<script>
import { mapState } from 'vuex'
export default {
  name: 'PopBox',
  props:{
  },
  computed: {
    ...mapState(['popData']),
    isShow: {
      get(){
        return this.popData.showPop
      },
      set(){
        this.$store.dispatch('deletePopSlot')
      }
    },
  },
  render(){
    const selfCom = this.popData.slotData
    if(!selfCom) return false
    const fn = () => {
      document.querySelector('#app').style.background = '#000a3b';
      this.isShow = false;
    }
    if(this.isShow) {
      return (
        <div
          class="Bigbox"
          onClick={ fn }
        >
          <div onClick={ e => e.stopPropagation() } class="tableBox">
            <box-border
              {
                ...{
                  props:{
                    ...selfCom.$props,
                    width: '100%',
                    height: '100%',
                    spanShow: false
                  },
                  scopedSlots: { ...selfCom.$scopedSlots } 
                }
              }
            >
              {
                Object.keys(selfCom.$slots).map(name => (
                  <template slot={name}>{selfCom.$slots[name]}</template>
                ))
              }
            </box-border>
          </div>
        </div>
      )
    }
    return false;
  }
}
</script>
<style lang="less" scoped>
.Bigbox {
  width: 100%;
  height: 100%;
  position: fixed;
  top:0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.3);
  z-index: 999;
}
.tableBox {
  width: 90%;
  height: 90%;
  max-height: 90%;
  background: #000a3b;
  border: 2px solid #006CC8;
  cursor: pointer;
}
tbody::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
  display: none;
}
tbody::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: #272525;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent 100%
  );
}
tbody::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}
.pure-table-bordered {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  text-align: center;
  tbody{
    overflow: auto;
    width: 100%;
    height: 5rem;
    display: block;
    &:hover{
      width: calc(100% + 3px);
      &::-webkit-scrollbar{
        display: block;
      }
    }
  }
  tr{
    width: 100%;
    display: table;
    table-layout: fixed;
    box-sizing: border-box;
  }
  th,
  td {
    border: 1px solid #517FB5;
    &:first-child {
      border-left: none;
    }
    &:last-child {
      border-right: none;
    }
  }
  th {
    font-size: 0.15rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #02d9fd;
    padding: 0.13rem 0;
  }
  td {
    font-size: 0.14rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    padding: 0.09rem 0.2rem;
    word-wrap:break-word;
  }
  tr:first-child th {
    border-top: none;
  }
  tr:last-child td {
    border-bottom: none;
  }
}
</style>